// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueKindergarten from 'vue-kindergarten';
import Notifications from 'vue-notification';
import BootstrapVue from 'bootstrap-vue';
import VueClipboard from 'vue-clipboard2';
import VueAnalytics from 'vue-analytics';
import Icon from 'vue-awesome/components/Icon';
import VueI18n from 'vue-i18n';
import validationMessages from 'vee-validate/dist/locale/es';
import VeeValidate from 'vee-validate';
import Vue2Filters from 'vue2-filters';
import VuejsDialog from 'vuejs-dialog';
import { rutFilter, rutInputDirective } from 'vue-dni';
import 'vue-awesome/icons';
import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import './assets/css/kexa-styles.scss';
import App from './App';
import router from './router';
import store from './store';
import './filters/filters';
import child from './child';
import esCL from './locals/es_CL.json';
import esPE from './locals/es_PE.json';
import esMX from './locals/es_MX.json';
import ReloadAppDialog from './components/ReloadAppDialog';

Vue.use(VueKindergarten, {
  child,
});

Vue.use(VueI18n);

const i18n = new VueI18n({
  messages: {
    es_PE: esPE,
    es_CL: esCL,
    es_MX: esMX,
  },
});

switch (location.host.split('.').pop()) {
  case 'pe':
    i18n.locale = 'es_PE';
    break;
  case 'mx':
    i18n.locale = 'es_MX';
    break;
  default:
    i18n.locale = 'es_CL';
    break;
}

Vue.use(VeeValidate, {
  fieldsBagName: 'veeFields',
  i18nRootKey: 'validations',
  i18n,
  dictionary: {
    es_CL: validationMessages,
    es_PE: validationMessages,
  },
});

Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueClipboard);
Vue.use(Vue2Filters);
Vue.use(VuejsDialog, {
  okText: 'Continuar',
  cancelText: 'Cancelar',
});
Vue.component('icon', Icon);
Vue.filter('rutFilter', rutFilter);
Vue.directive('rut', rutInputDirective);
Vue.use(VueAnalytics, {
  id: 'UA-48735171-18',
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  store,
  i18n,
});

Vue.component('ReloadAppDialog', ReloadAppDialog);



// WEBPACK FOOTER //
// ./src/main.js